import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const MentionEducationTip: FC<SandboxEducationTipProps> = (props) => (
  <EducationTip
    anchor={props.anchor}
    position="top"
    isVisible={props.isVisible}
    isStandalone
    onRequestClose={noop}
    pillType={InfoBubblePillVariantsEnum.EDUCATION}
    title={
      <Trans id="infobubble-onboarding-mention-title">
        Send a comment
        <br />
        &ldquo;@marisa_demo can you help?&rdquo;
      </Trans>
    }
    stepCounter={generateStepText(2, 2)}
    dataObjectName={OnboardingDataEventObject.DEMO_MENTION}
  >
    <Trans id="infobubble-onboarding-mention-description">
      Comments are internal notes that allow you to collaborate with teammates behind the scenes. Give it a
      try by sending a comment mentioning your demo teammate Marisa.
    </Trans>
  </EducationTip>
);
